import { Host, h } from "@stencil/core";
import { ButtonAppearance } from "./oh-button.types";
import { SlotPosition } from "../oh-link/oh-link.types";
import { remCalc } from "../../styles";
import { DataLayerService, EventName } from "../../utils/services/datalayer";
import { TrackingObjectBuilder } from "../../utils/services/datalayer/tracking-object-builder";
export class OhButton {
    constructor() {
        this.text = undefined;
        this.disabled = undefined;
        this.fullWidth = undefined;
        this.appearance = undefined;
        this.slotPosition = SlotPosition.LEFT;
        this.loading = false;
        this.inheritFontSize = false;
        this.parentComponent = undefined;
    }
    handleEvent() {
        this.ohButtonClick.emit();
        if (this.parentComponent) {
            DataLayerService.pushEvent(EventName.BUTTON, new TrackingObjectBuilder().forButtonClick({ clickText: this.text, parentComponent: this.parentComponent }));
        }
    }
    render() {
        const buttonClasses = {
            'link--text link--underline': this.appearance === ButtonAppearance.TEXT,
            'link--text button--underline button--inline': this.appearance === ButtonAppearance.TEXT_INLINE,
            'link--text': this.appearance === ButtonAppearance.TEXT_UNDERLINED,
            'button--contained button--contained--dark': this.appearance === ButtonAppearance.CONTAINED_DARK,
            'button--contained button--contained--primary': this.appearance === ButtonAppearance.CONTAINED_PRIMARY,
            'button--outline': this.appearance === ButtonAppearance.OUTLINE,
            'button--outline button--outline--dark': this.appearance === ButtonAppearance.OUTLINE_DARK,
            'button--reset': this.appearance === ButtonAppearance.RESET,
            'full-width': this.fullWidth,
            'font-size-inherit': this.inheritFontSize,
        };
        return (h(Host, { key: '7d4ae5b6b0636d86d91fa3d8d4584cdbcb709cc3' }, h("button", { key: '3182597e60fd1e6486235f0a286bab1379629097', part: "button", class: buttonClasses, disabled: this.loading || this.disabled, onClick: () => this.handleEvent(), title: this.text }, this.slotPosition === SlotPosition.LEFT && h("slot", { key: 'f4adbec273ba7b497850419bebfd57761e1fd8d2' }), h("div", { key: '33268ff1d10c7e9a0c997c017f2d9ed63a7f8a7a', class: this.appearance === ButtonAppearance.TEXT_UNDERLINED && 'underlined' }, this.loading && h("oh-loader", { key: '1e69363d391fd10a273888ad889fdd882361ef98', size: `${remCalc(18)}rem`, noPadding: true }), this.text), this.slotPosition === SlotPosition.RIGHT && h("slot", { key: '34eefcfeb4a04f3190e787d50b073e3b9bc96a92' }))));
    }
    static get is() { return "oh-button"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["oh-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["oh-button.css"]
        };
    }
    static get properties() {
        return {
            "text": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "text",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "disabled",
                "reflect": false
            },
            "fullWidth": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "full-width",
                "reflect": false
            },
            "appearance": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ButtonAppearance",
                    "resolved": "ButtonAppearance.CONTAINED_DARK | ButtonAppearance.CONTAINED_PRIMARY | ButtonAppearance.OUTLINE | ButtonAppearance.OUTLINE_DARK | ButtonAppearance.RESET | ButtonAppearance.TEXT | ButtonAppearance.TEXT_INLINE | ButtonAppearance.TEXT_UNDERLINED",
                    "references": {
                        "ButtonAppearance": {
                            "location": "import",
                            "path": "./oh-button.types",
                            "id": "src/components/oh-button/oh-button.types.ts::ButtonAppearance"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "appearance",
                "reflect": false
            },
            "slotPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "SlotPosition",
                    "resolved": "SlotPosition.LEFT | SlotPosition.RIGHT",
                    "references": {
                        "SlotPosition": {
                            "location": "import",
                            "path": "../oh-link/oh-link.types",
                            "id": "src/components/oh-link/oh-link.types.ts::SlotPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "slot-position",
                "reflect": false,
                "defaultValue": "SlotPosition.LEFT"
            },
            "loading": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "loading",
                "reflect": false,
                "defaultValue": "false"
            },
            "inheritFontSize": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "inherit-font-size",
                "reflect": false,
                "defaultValue": "false"
            },
            "parentComponent": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "parent-component",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "ohButtonClick",
                "name": "ohButtonClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "Event",
                    "resolved": "Event",
                    "references": {
                        "Event": {
                            "location": "import",
                            "path": "@stencil/core",
                            "id": "node_modules::Event"
                        }
                    }
                }
            }];
    }
}
//# sourceMappingURL=oh-button.js.map
